import { Component, HostBinding, Input, OnChanges, ViewChild } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { TimerService } from '@frontend/sports/common/core/utils/timer';

import { TabBarItem } from '../../tab-bar/tab-bar.models';
import { ShowcaseEventModel } from '../showcase.model';
import { ShowcaseService } from '../showcase.service';
import { ShowcaseTrackingService } from '../showcase.tracking.service';

@Component({
    selector: 'ms-showcase-tab-bar',
    templateUrl: 'showcase-tab-bar.html',
})
export class TabsShowcaseComponent implements OnChanges {
    @Input() events: ShowcaseEventModel[];
    @Input() scrollSize = 200;
    @Input() scrollEnabled = true;
    @Input() stretch = false;
    @Input() selectedEventId: string;
    @Input() scrollNeeded: boolean;
    activeEventid: string;

    @HostBinding('class') className = 'tab-bar';

    @ViewChild(ScrollAdapterComponent) scrollAdapter: ScrollAdapterComponent;

    constructor(
        private timer: TimerService,
        private showcaseService: ShowcaseService,
        private showcaseTrackingService: ShowcaseTrackingService,
    ) {}

    ngOnChanges(changes: ISimpleChanges<TabsShowcaseComponent>): void {
        if (this.scrollEnabled && changes.events && !changes.events.firstChange) {
            this.timer.setTimeout(() => this.scrollAdapter.setArrows());
        }
        if ((changes.selectedEventId || changes.scrollNeeded) && !this.showcaseService.eventSelectedFromTabBar) {
            this.timer.setTimeout(() => this.scrollAdapter.updatedScrollPosition());
        }
        if (changes.selectedEventId) {
            this.activeEventid = changes.selectedEventId.currentValue;
        }
    }

    selected(domEvent: Event, event: ShowcaseEventModel, index: number): void {
        domEvent.preventDefault();
        this.showcaseService.eventSelectedFromTabBar = true;
        this.showcaseService.select(event.event.id);
        this.showcaseTrackingService.trackEventSwitcherEventClick(event.event, index);
    }

    trackTabsBy(index: number, tab: TabBarItem): number {
        return tab.id;
    }
}
